<template>
  <div class="questionDetail">
    <!-- 进入页面等待，所有接口请求 -->
    <div class="custom-loading" v-if="loading">
      <van-loading color="#0094ff">加载中...</van-loading>
    </div>
    <!-- 加载完毕逻辑 -->
    <div v-else>
      <!--1. 判断是否已作答完成  -->
      <template v-if="!success">
        <!-- 2.判断是否可以作答, canwrite -->
        <div v-if="canwrite" class="contentArea">
          <!-- 不能作答 -->
          <div class="notArea">
            <img src="../../assets/images/detailBg.png" alt="" />
          </div>
          <div class="introTitle">
            “非常抱歉”
          </div>
          <div class="introContent">
            {{ tips }}不要灰心，我们将<span style="color:red">不定时推送问卷，请持续关注</span>。
          </div>
          <!-- <div class="shareBtn" @click="shareQuestion">
            分享领惊喜
          </div> -->
        </div>
        <template v-else>
          <van-notice-bar
            v-if="status === 0"
            color="#1989fa"
            background="#ecf9ff"
            left-icon="info-o"
          >
            问卷暂未发布，无法提交，仅提供预览！
          </van-notice-bar>
          <!-- 可以作答-->
          <template v-if="showQuestion">
            <van-popup
              v-model="showInput"
              class="customInputContent"
              position="top"
              :style="{ height: '10%' }"
            >
              <van-field
                ref="customInput"
                placeholder="请输入"
                v-model="inputContent"
                @input="inputChange"
                maxlength="20"
              />
            </van-popup>
            <div class="content" v-if="anserList.length > 0">
              <div class="title">
                {{ detailInfo.name }}
              </div>
              <div class="remark">
                {{ detailInfo.remark }}
              </div>
              <div class="splitLine"></div>
              <div class="list" ref="customList">
                <!-- 补充两道题, 应急措施只有奶牛问卷不显示这两道题 -->
                <div class="item" v-if="Number(qid) === 7">
                  <div class="item-title">
                    <span class="required">
                      <img
                        src="../../assets/images/svg/required.svg"
                        class="required-icon"
                        alt=""
                      />
                    </span>
                    <span class="index"> 1、</span>
                    <span class="question">您的家乡近期是否遭受洪涝灾害？</span>
                  </div>
                  <div class="item-question-model">
                    <van-radio-group class="custom-check-template" v-model="addQuestionList[0]">
                      <van-radio name="是" class="custom-check">是</van-radio>
                      <van-radio name="否" class="custom-check">否</van-radio>
                    </van-radio-group>
                  </div>
                </div>
                <div class="item" v-if="Number(qid) === 7">
                  <div class="item-title">
                    <span class="required">
                      <img
                        src="../../assets/images/svg/required.svg"
                        class="required-icon"
                        alt=""
                      />
                    </span>
                    <span class="index"> 2、</span>
                    <span class="question">水稻产量受此次灾情影响是否严重？</span>
                  </div>
                  <div class="item-question-model">
                    <van-radio-group class="custom-check-template" v-model="addQuestionList[1]">
                      <van-radio name="是" class="custom-check">是</van-radio>
                      <van-radio name="否" class="custom-check">否</van-radio>
                    </van-radio-group>
                  </div>
                </div>
                <!-- 补充两道题结束 -->
                <div
                  v-for="(item, qIndex) in anserList"
                  :key="item.id"
                  class="item"
                  :ref="'question_' + qIndex"
                  :class="{ showItem: checkShow(item, answers, qIndex) }"
                >
                  <div class="item-title">
                    <span class="required">
                      <img
                        v-if="Number(item.flag) === 1"
                        src="../../assets/images/svg/required.svg"
                        class="required-icon"
                        alt=""
                      />
                    </span>
                    <span class="index" v-if="Number(qid) === 7"> {{ qIndex + 3 }}、</span>
                    <span class="index" v-else>{{ getNum(item) }}、</span>
                    <span class="question">{{ item.question }}</span>
                    <span v-if="item.unit" class="unit">（单位：{{ item.unit }}）</span>
                    <span class="type" v-if="Number(item.qtype) === 2">【多选题】</span>
                  </div>
                  <div v-if="item.descri" class="item-descri">({{ item.descri }})</div>
                  <div class="item-question-model">
                    <!--  填空题模板 -->
                    <template v-if="Number(item.qtype) === 0">
                      <div class="custom-input-template">
                        <div class="default">
                          <van-field
                            placeholder="请输入"
                            :type="Number(item.atype) === 0 ? 'text' : 'number'"
                            v-model="answers[qIndex].answer"
                            @input="debouceChangeInput(item, qIndex)"
                          />
                        </div>
                      </div>
                    </template>
                    <!--  单选框模板 -->
                    <template v-if="Number(item.qtype) === 1">
                      <van-radio-group
                        v-model="answers[qIndex].answer"
                        class="custom-check-template"
                      >
                        <van-radio
                          v-for="(rOption, rIdx) in item.answer"
                          :key="qIndex + '-' + rIdx"
                          :name="rIdx"
                          class="custom-check"
                          @click="clickRadio($event, qIndex, rIdx)"
                        >
                          {{ rOption.value }}
                        </van-radio>
                      </van-radio-group>
                    </template>
                    <!-- 多选框模板 -->
                    <template v-if="Number(item.qtype) === 2">
                      <van-checkbox-group
                        v-model="answers[qIndex].answer"
                        class="custom-check-template"
                      >
                        <van-checkbox
                          shape="square"
                          v-for="(cOption, cIdx) in item.answer"
                          :key="qIndex + '-' + cIdx"
                          class="custom-check"
                          :name="cIdx"
                          @click="clickCheckBox($event, qIndex, cIdx)"
                        >
                          {{ cOption.value }}
                        </van-checkbox>
                      </van-checkbox-group>
                    </template>
                    <!-- 日期模板 -->
                    <template v-if="Number(item.qtype) === 3">
                      <div class="custom-input-template" @click="chooseTime(qIndex)">
                        <div class="default">
                          <img src="../../assets/images/svg/date.svg" alt="" class="icon" />
                          <input
                            class="sudiao-input"
                            readonly
                            v-model="answers[qIndex].answer"
                            placeholder="请选择"
                          />
                        </div>
                      </div>
                    </template>
                    <!-- 文件上传模板 -->
                    <template v-if="Number(item.qtype) === 4">
                      <!-- <wx-open-launch-weapp
                        id="launch-weapp1"
                        username="gh_0f12b8c2673a"
                        :path="wepppath"
                        @launch="onLaunch"
                        @error="onError"
                      >
                        <script type="text/wxtag-template">
                          <style>.wxappUpload { margin-top:10px;width: 50px; height:50px;border: 1px dashed #cdcdcd; border-radius: 5px }</style>
                          <image
                            src="{{ qimageAddress || 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNENEQ0RDQ7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTE2LjMsOTAuMmM5LjIsOS4yLDkuMiwyNC4xLDAsMzMuNHMtMjQuMSw5LjItMzMuNCwwcy05LjItMjQuMSwwLTMzLjRTMTA3LjEsODEsMTE2LjMsOTAuMiIvPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNOTkuNywxNDMuOGMtMjAuNiwwLTM2LjktMTYuMi0zNi45LTM2LjlTNzksNzAuMSw5OS43LDcwLjFzMzYuOSwxNi4yLDM2LjksMzYuOVMxMjAuMywxNDMuOCw5OS43LDE0My44egoJIE03Ny41LDMzLjJMNjQuMyw0Ny45SDQwLjdjLTguMSwwLTE0LjcsNi42LTE0LjcsMTQuN3Y4OC41YzAsOC4xLDYuNiwxNC43LDE0LjcsMTQuN2gxMThjOC4xLDAsMTQuNy02LjYsMTQuNy0xNC43VjYyLjcKCWMwLTguMS02LjYtMTQuNy0xNC43LTE0LjdIMTM1bC0xMy4zLTE0LjdMNzcuNSwzMy4yeiIvPgo8L3N2Zz4K'}}"
                            alt=""
                            class="wxappUpload"
                          />
                        </script>
                      </wx-open-launch-weapp> -->
                      <div class="custom-file-template">
                        <van-uploader
                          v-model="answers[qIndex].fileList"
                          :max-size="10 * 1024 * 1024"
                          @oversize="onOversize"
                          :after-read="afterRead"
                          :before-read="beforeRead"
                          :max-count="1"
                          :name="qIndex"
                          capture="camera"
                          @delete="deleteFile(qIndex)"
                        >
                        </van-uploader>
                      </div>
                    </template>
                    <!-- 手机号模板 -->
                    <template v-if="Number(item.qtype) === 5">
                      <!-- <van-field placeholder="请输入" v-model="answers[qIndex].answer" type="tel" maxlength="11" /> -->
                      <div class="custom-input-template">
                        <div class="default">
                          <img src="../../assets/images/svg/phone.svg" alt="" class="icon" />
                          <!-- <input class="sudiao-input"  v-model="answers[qIndex].answer" maxlength="11" placeholder="请输入"/> -->
                          <van-field
                            placeholder="请输入"
                            v-model="answers[qIndex].answer"
                            type="tel"
                            maxlength="11"
                          />
                        </div>
                      </div>
                    </template>
                    <!-- 地理位置模板模板 -->
                    <template v-if="Number(item.qtype) === 6">
                      <div class="custom-input-template" @click="choosePos(qIndex)">
                        <div class="default">
                          <img src="../../assets/images/svg/position.svg" alt="" class="icon" />
                          <input
                            class="sudiao-input"
                            readonly
                            v-model="answers[qIndex].answer"
                            placeholder="请选择"
                          />
                        </div>
                      </div>
                    </template>
                    <!-- 自增表单 -->
                    <template v-if="item.qtype === 7">
                      <!-- 内关联逻辑先不 -->
                      <div class="myAddForm">
                        <div class="subtitle flex jc-between ai-center">
                          <div>{{ item.subtitle || '' + '1' }}</div>
                          <div class="flex ai-center">
                            <img
                              @click="addOneForm(item, qIndex)"
                              src="../../assets/images/svg/add.svg"
                              class="addIcon"
                            />
                          </div>
                        </div>
                        <div
                          v-for="(pro, adx) in item.pros"
                          :key="adx"
                          class="zzbd"
                          :class="{
                            showZzbd: checkShowForm(pro, answers[qIndex].pros, adx, item.pros)
                          }"
                        >
                          <div class="item-title">
                            <span class="required">
                              <img
                                v-if="Number(pro.flag) === 1"
                                src="../../assets/images/svg/required.svg"
                                class="required-icon"
                                alt=""
                              />
                            </span>
                            <span class="question">{{ pro.question }}</span>
                            <span v-if="pro.unit" class="unit">（单位：{{ pro.unit }}）</span>
                            <span class="type" v-if="Number(pro.qtype) === 2">【多选题】</span>
                          </div>
                          <!-- <div v-if="item.descri" class="item-descri">
                            ({{ item.descri }})
                          </div> -->
                          <template v-if="pro.qtype === 0">
                            <div class="item-question-model">
                              <div class="custom-input-template">
                                <div class="default">
                                  <van-field
                                    placeholder="请输入"
                                    :type="Number(item.atype) === 0 ? 'text' : 'number'"
                                    v-model="answers[qIndex].pros[adx].answer"
                                  />
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="pro.qtype === 1">
                            <van-radio-group
                              v-model="answers[qIndex].pros[adx].answer"
                              class="custom-check-template"
                            >
                              <van-radio
                                v-for="(rOption, rIdx) in pro.answer"
                                :key="qIndex + '-' + rIdx"
                                :name="rIdx"
                                class="custom-check"
                                @click="clickRadio($event, qIndex, rIdx, adx, undefined, 'pros')"
                              >
                                {{ rOption.value }}
                              </van-radio>
                            </van-radio-group>
                          </template>
                          <template v-if="pro.qtype === 2">
                            <van-checkbox-group
                              v-model="answers[qIndex].pros[adx].answer"
                              class="custom-check-template"
                            >
                              <van-checkbox
                                shape="square"
                                v-for="(cOption, cIdx) in pro.answer"
                                :key="qIndex + '-' + cIdx"
                                class="custom-check"
                                :name="cIdx"
                                @click="clickCheckBox($event, qIndex, cIdx, adx, undefined, 'pros')"
                              >
                                {{ cOption.value }}
                              </van-checkbox>
                            </van-checkbox-group>
                          </template>
                        </div>
                      </div>
                      <!-- 补充自增表单 -->
                      <template v-if="item.multipleIds">
                        <div
                          v-for="(field, fx) in item.multipleIds"
                          :key="'field' + fx"
                          class="myAddForm"
                        >
                          <div class="subtitle flex jc-between ai-center">
                            <div>
                              {{ item.subtitle || '' + Number(fx + 2) }}
                            </div>
                            <div class="flex ai-center">
                              <img
                                src="../../assets/images/svg/remove.svg"
                                @click="removeOneForm(item, qIndex, fx)"
                                class="removeIcon"
                              />
                              <img
                                @click="addOneForm(item, qIndex)"
                                src="../../assets/images/svg/add.svg"
                                class="addIcon"
                              />
                            </div>
                          </div>
                          <div
                            v-for="(pro, adx) in field"
                            :key="adx"
                            class="zzbd"
                            :class="{
                              showZzbd: checkShowForm(
                                pro,
                                answers[qIndex].multipleIds[fx],
                                adx,
                                field
                              )
                            }"
                          >
                            <div class="item-title">
                              <span class="required">
                                <img
                                  v-if="Number(pro.flag) === 1"
                                  src="../../assets/images/svg/required.svg"
                                  class="required-icon"
                                  alt=""
                                />
                              </span>
                              <span class="question">{{ pro.question }}</span>
                              <span v-if="pro.unit" class="unit">（单位：{{ pro.unit }}）</span>
                              <span class="type" v-if="Number(pro.qtype) === 2">【多选题】</span>
                            </div>
                            <!-- <div v-if="item.descri" class="item-descri">
                              ({{ item.descri }})
                            </div> -->
                            <template v-if="pro.qtype === 0">
                              <div class="item-question-model">
                                <div class="custom-input-template">
                                  <div class="default">
                                    <van-field
                                      placeholder="请输入"
                                      :type="Number(item.atype) === 0 ? 'text' : 'number'"
                                      v-model="answers[qIndex].multipleIds[fx][adx].answer"
                                    />
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-if="pro.qtype === 1">
                              <van-radio-group
                                v-model="answers[qIndex].multipleIds[fx][adx].answer"
                                class="custom-check-template"
                              >
                                <van-radio
                                  v-for="(rOption, rIdx) in pro.answer"
                                  :key="qIndex + '-' + rIdx"
                                  :name="rIdx"
                                  class="custom-check"
                                  @click="clickRadio($event, qIndex, rIdx, fx, adx, 'multiple')"
                                >
                                  {{ rOption.value }}
                                </van-radio>
                              </van-radio-group>
                            </template>
                            <template v-if="pro.qtype === 2">
                              <van-checkbox-group
                                v-model="answers[qIndex].multipleIds[fx][adx].answer"
                                class="custom-check-template"
                              >
                                <van-checkbox
                                  shape="square"
                                  v-for="(cOption, cIdx) in pro.answer"
                                  :key="qIndex + '-' + cIdx"
                                  class="custom-check"
                                  :name="cIdx"
                                  @click="clickCheckBox($event, qIndex, cIdx, fx, adx, 'multiple')"
                                >
                                  {{ cOption.value }}
                                </van-checkbox>
                              </van-checkbox-group>
                            </template>
                          </div>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <div class="submitButton">
                <div class="custom-button" @click="onSubmit">
                  提交
                </div>
              </div>
            </div>
            <!-- <div class="shareBtn" @click="shareQuestion">
              分享领惊喜
            </div> -->
          </template>
          <div v-else class="contentArea">
            <!-- 显示信息， 两种状态, 1. 直接作答，2 提示用户有可能无法获取奖励，继续作答 -->
            <div class="notArea">
              <img src="../../assets/images/detailBg.png" alt="" />
            </div>
            <div class="introTitle">
              “感谢您参与此次调研”
            </div>
            <div v-if="cannot" class="introContent">
              <!-- 应急措施 乳业问卷 -->
              <!-- <template v-if="Number(qid) === 21">
                由于参与人数较多，您的此次参与<span style="color:red">可能无法获得奖励</span>。
                <br/>
                您好！我们正在进行一项我国城镇居民乳制品消费的调查研究，您的意见对我们非常重要，为更好地为消费者服务提供帮助，谢谢您的支持与合作! 
              </template>
              <template v-else>
                由于参与人数较多，您的此次参与<span style="color:red">可能无法获得奖励</span>。
                <br/>
                本次调研仅针对<span style="color:red">水稻种植户</span>，请认真按照真实情况填写。
                <br/>
                以下情况不会审核通过，<span style="color:red">无法获得奖励，请勿参与！！！</span>
                <br/>
                1、不是水稻种植户
                <br/>
                2、百度或者随便填写的数据
                <br/>
                3、不是真实拍摄自家田间照片
              </template> -->
              由于参与人数较多，您的此次参与<span style="color:red">可能无法获得奖励</span>。
              <div v-if="gstatus" v-html="gcontent" class="customHtml"></div>
            </div>
            <div v-else class="introContent">
              <!-- 应急措施 乳业问卷 -->
              <div class="guide-html customHtml" v-if="gstatus" v-html="gcontent"></div>
              <!-- <template v-if="Number(qid) === 21">
                您好！我们正在进行一项我国城镇居民乳制品消费的调查研究，您的意见对我们非常重要，为更好地为消费者服务提供帮助，谢谢您的支持与合作! 
              </template>
              <template v-else>
                本次调研仅针对<span style="color:red">水稻种植户</span>，请认真按照真实情况填写，红包将在审核通过后发放。
                <br/>
                以下情况不会审核通过，<span style="color:red">无法获得奖励，请勿参与！！！</span>
                <br/>
                1、不是水稻种植户
                <br/>
                2、百度或者随便填写的数据
                <br/>
                3、不是真实拍摄自家田间照片
              </template> -->
            </div>
            <!-- <div class="shareBtn" @click="shareQuestion">
              分享领惊喜
            </div> -->
            <div class="waiting">
              <div v-if="isWaiting" class="waitingBtn isWaiting">{{ second }}s后可答题</div>
              <div v-else @click="startAnser" class="waitingBtn">
                立即答题
              </div>
            </div>
          </div>
        </template>
        <!-- 其他项输入框 -->
      </template>
      <div class="success" v-else>
        <div class="successContent">
          <img :src="successImg" alt="" class="shareImg" />
          <!-- <div class="thanks">“感谢您参与此次调研，问卷将在五个工作日内审核完成，审核通过后将有红包推送。诚邀您参与分享有奖活动，好友通过您的分享参与调查后您将获得丰厚红包奖励。”</div> -->
          <div class="introTitle">
            “感谢您参与此次调研”
          </div>
          <div class="introContent">
            <!-- 感谢您参与调查，红包将在审核通过后发放，请耐心等待。 -->
            感谢您参与调查，请耐心等待问卷审核。
            <br />
            <!-- 诚邀您参与<span style="color:red">分享有奖</span> 活动，好友通过您的分享参与，并审核通过后，您将获得2元至5元<span style="color:red">红包奖励</span>。 -->
          </div>
          <div class="buttons">
            <!-- <div class="shareButton button" @click="shareQuestion">分享有奖</div> -->
            <div class="returnButton button" @click="goBack">返回个人中心</div>
          </div>
          <div class="caution">中国农业科学院农业信息研究所</div>
        </div>
      </div>
      <van-popup v-model="showTimePicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="confirmTime"
          @cancel="showTimePicker = false"
        />
      </van-popup>
      <van-popup v-model="showPosPicker" position="bottom">
        <van-area
          :area-list="areaJson"
          v-model="code"
          @confirm="confirmPos"
          @cancel="showPosPicker = false"
        />
      </van-popup>
      <shareDialog :show="showShareInfo" @closeDialog="closeShare"></shareDialog>
    </div>
  </div>
</template>

<script>
import { getImage, deleteUploadFile, getAreaJSON } from '../../api/common'
import { getQueDetail, getGuide } from '../../api/question'
import { getJudge, checckJudge, insertAnswer } from '../../api/anser'
import { formatTime, getQueryString, checkPhone, checkValidUserPhone } from '../../util/index'
import store from '../../store/index'
import wx from 'weixin-js-sdk'
import custom_wx from '../../util/wx'
import axios from 'axios'
import Compressor from 'compressorjs'
import { unescape } from 'html-escaper'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import { checkUserInfo } from '@/api/user'
export default {
  async beforeRouteEnter(to, from, next) {
    try {
      const userInfo = store.getters.userInfo
      store.commit('setGlobalLoading', true)
      let res = await checkUserInfo({ openid: userInfo.user.openid })
      store.commit('setGlobalLoading', false)
      const { phone, subscribe, status } = res.data
      // 检查用户状态是否正常， 不正常走登录逻辑
      if (phone === 1 && subscribe === 1 && status === 1) {
        next()
      } else {
        localStorage.setItem('nextgo', window.location.hash)
        next('/login')
      }
    } catch (error) {
      store.commit('setGlobalLoading', false)
    }
  },
  beforeCreate() {
    const q_id = getQueryString('qid', 'hash')
    const userInfo = store.getters.userInfo
    location.hash = `#/question/detail?qid=${q_id}&t_id=${userInfo.user.id}`
    custom_wx.initConfig()
  },
  data() {
    return {
      timer: '',
      isWaiting: false,
      second: 1,
      showQuestion: false,
      uploadSvg: require('../../assets/images/svg/upload.svg'),
      loading: true,
      showFocus: false,
      // isRequest: false,
      fileList: [],
      isRequest: false,
      showShareInfo: false,
      successImg: require('../../assets/images/question/success_update.png'),
      userInfo: {},
      success: false, // 答题成功标识
      showInput: false, // 选择其他选项，输入框弹窗
      qIndex: '', // 列表item选中索引
      cIndex: '', // radio 或 checkbox 选项索引
      inputContent: '', // 输入框内容
      // 自增表单其他项输入变化
      // pros代表原始自增项，multiple表示新增的自增项
      zzInputType: undefined,
      zzFormIndex: '', // 自增索引
      zzMutipleIndex: '', // 自增mutipleIndex索引
      dateImg: require('../../assets/images/icon/date.png'),
      code: '', // 省市县区号
      cannot: false, // 能否获取奖励标识， false: 可以 true: 不可以
      canwrite: false,
      showPosPicker: false, // 位置选择弹窗
      showTimePicker: false, // 时间选择弹窗
      qid: '', // 问卷id
      areaJson: {}, // 省市县列表
      detailInfo: {}, // 问卷信息
      anserList: [], // 问卷列表
      answers: [], // 答案列表
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(2050, 11, 31),
      currentDate: new Date(),
      location: {},
      startTime: 0, // 答题开始时间
      itemIndex: '', //第几个问题
      image: 2, // 图片元信息状态
      exifInfo: {
        make: '',
        model: '',
        dateTime: '',
        longitude: '',
        latitude: ''
      },
      wepppath: '',
      addQuestionList: ['', ''], // 新增问题
      qimageAddress: '', // 用户上传图片地址
      gcontent: '感谢您参与此次问卷调查，请认真填写。',
      tips: '', // 无法答题的提示语
      status: 0 // 问卷状态
    }
  },
  async created() {
    const userInfo = store.getters.userInfo
    // input change
    this.debouceChangeInput = debounce(this.changeInput, 100)
    this.userInfo = userInfo
    console.log('userinfo', userInfo)
    const qid = this.$route.query.qid
    this.qid = qid
    this.wepppath = `pages/upload/index?uid=${userInfo.user.id}&qid=${qid}&token=${userInfo.token}&domin=${process.env.VUE_APP_DOMIN}`
    let res = await checckJudge({ qcode: qid, uid: userInfo.user.id })
    // 获取行政区划表
    let areaJSON = await getAreaJSON()
    this.areaJson = areaJSON?.data || {}
    console.log(res)
    if (!res.data) {
      this.loading = false
      this.success = true
      return
    }
    // this.getQuestionDetail(this.qid)
    const _that = this
    // 调试环境定位
    if (location.hostname.indexOf(process.env.VUE_APP_HOSTNAME) === 0) {
      const lat = '39.916527' // 纬度，浮点数，范围为90 ~ -90
      const lon = '116.397128' // 经度，浮点数，范围为180 ~ -180。
      _that.location = { lat, lon }
      _that.checkAuth({
        uid: _that.userInfo.user.id,
        qcode: _that.qid,
        lat,
        lon
      })
      return
    }
    // 正式环境获取定位
    wx.ready(() => {
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          const lat = String(res.latitude) // 纬度，浮点数，范围为90 ~ -90
          const lon = String(res.longitude) // 经度，浮点数，范围为180 ~ -180。
          _that.location = { lat, lon }
          _that.checkAuth({
            uid: _that.userInfo.user.id,
            qcode: _that.qid,
            lat,
            lon
          })
        },
        fail(err) {
          //没有位置不让答题
          console.log(err)
          alert('获取定位信息失败，请打开手机定位')
          // _that.$router.replace('/my/index')
        },
        cancel: function() {
          _that.$router.replace('/question/index')
        }
      })
    })
  },
  methods: {
    // 检查是否显示
    checkShow(question, anserList, qIndex) {
      // 1. 判断本题是否有依赖项
      // 2. 如果有依赖项，判断依赖项是否显示  并且依赖项答案是否包含本题；
      const { dependId, dependOptions, relationIds, qtype, zzid } = question
      const answer = anserList[qIndex].answer // 本题答案
      if (zzid !== null && qtype === 7) {
        // 检查 自增表单的数量依赖项是否显示，进行联动
        let dependShow = this.anserList[Number(zzid)].show
        this.$set(question, 'show', dependShow && question.inputChangeShow)
        return dependShow && question.inputChangeShow
      } else {
        if (this.checkEmpty(dependId)) {
          // 没有dependId
          if (this.checkEmpty(relationIds)) {
            if (this.checkEmpty(answer)) {
              // 本题没有答案， 所有依赖项都不显示
              relationIds.forEach(relationId => {
                this.$set(this.anserList[relationId], 'show', false)
              })
            } else {
              // 本题有答案，判断关联的题目中 是否有选项跟自己对应
              relationIds.forEach(relationId => {
                if (qtype === 1) {
                  let res = this.anserList[relationId].dependOptions.includes(answer)
                  if (res) {
                    this.$set(this.anserList[relationId], 'show', true)
                  } else {
                    this.$set(this.anserList[relationId], 'show', false)
                  }
                } else if (qtype === 2) {
                  let res = answer.some(val =>
                    this.anserList[relationId].dependOptions.includes(val)
                  )
                  if (res) {
                    this.$set(this.anserList[relationId], 'show', true)
                  } else {
                    this.$set(this.anserList[relationId], 'show', false)
                  }
                }
              })
            }
          }
          this.$set(question, 'show', true)
          return true
        } else {
          // 有dependId
          const { answer: Ranswer, qtype: Rtype } = anserList[dependId]
          if (this.checkEmpty(Ranswer)) {
            this.$set(question, 'show', false)
            return false
          } else {
            // 依赖项有值， 并且包含答案， 还需要判断依赖项是否是显示的
            if (Rtype === 1) {
              // 依赖项单选
              let res = dependOptions.includes(Ranswer) && this.anserList[dependId].show
              this.$set(question, 'show', res)
              return res
            } else if (Rtype === 2) {
              // 依赖项多选
              let res =
                Ranswer.some(r => dependOptions.includes(r)) && this.anserList[dependId].show
              this.$set(question, 'show', res)
              return res
            }
          }
        }
      }
    },
    getNum(q) {
      let arr = this.anserList.filter(item => item.show)
      let num = arr.findIndex(item => {
        return item.show && item.id === q.id
      })
      return num + 1
    },
    // 获取问卷详情
    getQuestionDetail(qid) {
      getQueDetail({ qcode: qid }).then(res => {
        const { list, status } = res.data
        this.status = status
        // 问卷暂停提示
        if (status === 2) {
          this.tips = '很抱歉，问卷暂停收集，请稍后再试。'
          this.canwrite = true
        }
        list.map(item => {
          // 解析选择题 选项
          if (item.answer) {
            item.answer = JSON.parse(item.answer)
          }
          item.initialAnswer = cloneDeep(item.answer)
          // 初始化答案列表
          // this.answers.push({
          //   answer: Number(item.qtype) === 2 ? [] : '',
          //   // id: item.id,
          //   pid: item.id,
          //   result: '',
          //   qtype: item.qtype,
          //   flag: item.flag,
          // })
          let obj = {
            ...item,
            answer: Number(item.qtype) === 2 ? [] : '',
            // id: item.id,
            pid: item.id,
            result: '',
            qtype: item.qtype,
            flag: item.flag,
            // 保存最原始的问题选项和答案（如果单选和多选则包含选项）
            initialAnswer: cloneDeep(item.answer)
          }
          if (Number(item.qtype) === 4) {
            obj['fileList'] = []
          }
          // 自增表单处理
          let ansPros = []
          let pros = item.prosJson ? JSON.parse(item.prosJson) : []
          pros = pros.map(a => {
            // 初始化答案列表
            ansPros.push({
              answer: [2].includes(Number(a.qtype)) ? [] : '',
              result: '',
              qtype: a.qtype,
              flag: a.flag
            })
            // 问题列表
            const questionItem = {
              id: a.id,
              answer: [1, 2].includes(Number(a.qtype)) ? JSON.parse(a.answer) : '',
              question: a.question,
              atype: a.atype,
              flag: a.flag,
              dependId: this.checkEmpty(a.dependId) ? '' : Number(a.dependId),
              dependOptions: a.dependOptions ? a.dependOptions.split(',').map(b => Number(b)) : [],
              relationIds: a.relations ? a.relations.split(',').map(b => Number(b)) : [],
              descri: a.descri,
              qtype: Number(a.qtype),
              show: !this.checkEmpty(a.dependId) ? false : true
            }
            // 保存最原始的问题选项（如果单选和多选则包含选项）
            questionItem.initialAnswer = cloneDeep(questionItem.answer)
            return questionItem
          })
          obj.pros = ansPros
          // 增加自增的 multipleIds，TODO: 判断qtype为7
          obj.multipleIds = []
          item.multipleIds = []
          item.pros = pros
          this.answers.push(obj)
          this.anserList.push({
            ...item,
            show: this.checkEmpty(item.dependId),
            dependId: this.checkEmpty(item.dependId) ? '' : Number(item.dependId),
            dependOptions: this.checkEmpty(item.dependOptions)
              ? []
              : item.dependOptions.split(',').map(val => Number(val)),
            relationIds: this.checkEmpty(item.relationIds)
              ? []
              : item.relationIds.split(',').map(val => Number(val)),
            zzid: this.checkEmpty(item.zzid) ? null : Number(item.zzid)
          })
          return item
        })
        this.detailInfo = {
          ...res.data,
          list
        }
        this.loading = false
        this.isWaiting = true
        let timer = setInterval(() => {
          this.second -= 1
          if (this.second === 0) {
            this.isWaiting = false
            clearInterval(timer)
          }
        }, 1000)
        // 提示用户是否开始答题
        // const _that = this
        // this.$dialog.confirm({
        //   title: '提示',
        //   // message: '问卷已准备就绪，点击下方确定按钮即可开始答题！',
        //   message: '调查将在审核通过后发放红包奖励，请务必如实作答',
        //   showCancelButton: false,
        //   beforeClose(action, done) {
        //     if (action === 'confirm') {
        //       _that.startTime = new Date().getTime()
        //       done()
        //     }
        //   }
        // })
      })
    },
    // 添加一个自增表单addOneForm
    addOneForm(val, qIndex, hiddenNotify) {
      // 自增表单最大数量依赖
      let maxInputNum = val.maxInputNum
      if (maxInputNum !== undefined) {
        let multipleLength = val.multipleIds.length
        if (multipleLength >= maxInputNum - 1) {
          this.$notify({
            message: `本题最多添加${maxInputNum}个选项`,
            type: 'success'
          })
          return
        }
      }
      let ansPros = []
      val.pros.map(a => {
        ansPros.push({
          answer: [2].includes(Number(a.qtype)) ? [] : '',
          question: a.question,
          result: '',
          unit: a.unit,
          atype: a.atype,
          qtype: a.qtype,
          flag: a.flag
        })
        return a
      })
      // 添加答案列表
      this.answers[qIndex].multipleIds.push(ansPros)
      // 添加到问题列表
      let pros = JSON.parse(JSON.stringify(val.pros))
      pros = pros.map(a => {
        return {
          id: a.id,
          // 原始选项
          answer: cloneDeep(a.initialAnswer),
          initialAnswer: a.initialAnswer,
          question: a.question,
          unit: a.unit,
          atype: a.atype,
          flag: a.flag,
          dependId: a.dependId,
          dependOptions: a.dependOptions,
          relationIds: a.relationIds,
          descri: a.descri,
          qtype: Number(a.qtype),
          show: a.dependId || a.dependId === 0 ? false : true
        }
      })
      if (val.multipleIds) {
        val.multipleIds.push(pros)
      } else {
        this.$set(val, 'multipleIds', [pros])
      }
      if (!hiddenNotify) {
        this.$notify({
          message: '添加成功',
          type: 'success'
        })
      }
    },
    // 删除一个自增表单
    removeOneForm(val, qIndex, ax) {
      val.multipleIds.splice(ax, 1)
      this.answers[qIndex].multipleIds.splice(ax, 1)
    },
    /**
     * 不依赖自增表单的答案
     */
    checkShowForm(question, anserList, qIndex, arr) {
      // 1. 判断本题是否有依赖项
      // 2. 如果有依赖项，判断依赖项是否显示  并且依赖项答案是否包含本题；
      // 如果有数量依赖，则不检查
      const { dependId, dependOptions, relationIds, qtype } = question
      const answer = anserList[qIndex].answer // 本题答案
      if (this.checkEmpty(dependId)) {
        // 没有dependId
        if (!this.checkEmpty(relationIds)) {
          if (this.checkEmpty(answer)) {
            // 本题没有答案， 所有依赖项都不显示
            relationIds.forEach(relationId => {
              this.$set(arr[relationId], 'show', false)
            })
          } else {
            // 本题有答案，判断关联的题目中 是否有选项跟自己对应
            relationIds.forEach(relationId => {
              if (qtype === 1) {
                let res = arr[relationId].dependOptions.includes(answer)
                if (res) {
                  this.$set(arr[relationId], 'show', true)
                } else {
                  this.$set(arr[relationId], 'show', false)
                }
              } else if (qtype === 2) {
                let res = answer.some(val => arr[relationId].dependOptions.includes(val))
                if (res) {
                  this.$set(arr[relationId], 'show', true)
                } else {
                  this.$set(arr[relationId], 'show', false)
                }
              }
            })
          }
        }
        this.$set(question, 'show', true)
        return true
      } else {
        // 有dependId
        const { answer: Ranswer, qtype: Rtype } = anserList[dependId]
        if (this.checkEmpty(Ranswer)) {
          this.$set(question, 'show', false)
          return false
        } else {
          // 依赖项有值， 并且包含答案， 还需要判断依赖项是否是显示的
          if (Rtype === 1) {
            // 依赖项单选
            let res = dependOptions.includes(Ranswer) && arr[dependId].show
            this.$set(question, 'show', res)
            return res
          } else if (Rtype === 2) {
            // 依赖项多选
            let res = Ranswer.some(r => dependOptions.includes(r)) && arr[dependId].show
            this.$set(question, 'show', res)
            return res
          }
        }
      }
    },
    // 验证是否可以答题
    async checkAuth(config) {
      let res = await getGuide({ qcode: this.qid })
      console.log(res)
      if (res.data) {
        // parset html 并替换 slot 插槽内容
        let gcontent = res.data?.guide?.gcontent
        this.gstatus = !!res.data?.guide?.gstatus
        // 查找DOM节点并替换
        try {
          let unescapeContent = unescape(gcontent)
          let parser = new DOMParser()
          let doc = parser.parseFromString(unescapeContent, 'text/html')
          let slotMoney = doc.querySelector('.slot.money')
          let slotPrate = doc.querySelector('.slot.lv')
          let slotRed = doc.querySelector('.slot.redbag-result')
          slotMoney.innerHTML = res.data.money
          // 没有答过题的用户
          let qrate = res.data.prate
          slotPrate.innerHTML = qrate * 100 + '%'
          slotRed.innerHTML = res.data.nmoney
          this.gcontent = doc.body.innerHTML
        } catch (error) {
          // error
          // console.log(error);
        }
      }
      getJudge(config).then(res => {
        // console.log("judage", res);
        const { isFull, isTopLine, isUserTopLine } = res.data
        // isFull(是否满（1是0否）)
        // isTopLine 是否允许主产品（1是0否）
        // isUserTopLine 是否在主产县（1是0否）
        // const _this = this
        if (isTopLine === 0 && isUserTopLine === 0) {
          this.loading = false
          this.tips = '很遗憾，您所在的区域参与人数已满，下次请趁早。'
          this.canwrite = true
          // this.$dialog.confirm({
          //   title: '提示',
          //   // message: '问卷已准备就绪，点击下方确定按钮即可开始答题！',
          //   message: '很遗憾，您当前所在区域采集数量已满无法答题！',
          //   showCancelButton: false,
          //   beforeClose(action, done) {
          //     if (action === 'confirm') {
          //       _this.$router.replace('/question/index')
          //       done()
          //     }
          //   }
          // })
        } else {
          if (isFull === 1 || isUserTopLine === 0) {
            this.cannot = true
          }
          this.getQuestionDetail(this.qid)
          // 获取用户上传图片
          // while (!this.qimageAddress) {
          // this.getUserImg()
          // }
        }
        // if (!res.data) {
        //   this.cannot = true
        // }
      })
    },
    choosePos(index) {
      this.showPosPicker = true
      this.itemIndex = index
    },
    chooseTime(index) {
      this.showTimePicker = true
      this.itemIndex = index
    },
    // 省市县选择
    confirmPos(item) {
      const name = item[0].name + item[1].name + item[2].name
      const code = item[2].code
      this.$set(this.answers[this.itemIndex], 'answer', name)
      // this.code = code
      // 判断是否用于
      if (
        this.anserList[this.itemIndex].isadress &&
        this.anserList[this.itemIndex].isadress === 1
      ) {
        this.code = code
      }
      this.showPosPicker = false
    },
    // 时间确认
    confirmTime(val) {
      const time = formatTime(val)
      const timeStr = `${time.year}-${time.month}-${time.day}`
      this.$set(this.answers[this.itemIndex], 'answer', timeStr)
      this.showTimePicker = false
    },
    // 单选框变化,自增表单中其他项变化
    clickRadio(e, index, idx, zzFormIndex, zzMutipleIndex, zzInputType) {
      // 判断当前是否选中，并且是否是其他项
      this.zzInputType = zzInputType
      if (!zzInputType) {
        // 普通其他项
        if (
          this.answers[index].answer === idx &&
          this.anserList[index].answer[idx].type === 'else'
        ) {
          this.inputContent = ''
          this.showInput = true
          this.qIndex = index
          this.cIndex = idx
          this.$nextTick(() => {
            this.$refs.customInput.focus()
          })
        }
      } else if (zzInputType === 'pros') {
        // pros自增项
        if (
          this.answers[index].pros[zzFormIndex].answer === idx &&
          this.anserList[index].pros[zzFormIndex].answer[idx].type === 'else'
        ) {
          this.inputContent = ''
          this.showInput = true
          this.qIndex = index
          this.cIndex = idx
          this.zzFormIndex = zzFormIndex
          this.$nextTick(() => {
            this.$refs.customInput.focus()
          })
        }
      } else if (zzInputType === 'multiple') {
        if (
          this.answers[index].multipleIds[zzFormIndex][zzMutipleIndex].answer === idx &&
          this.anserList[index].multipleIds[zzFormIndex][zzMutipleIndex].answer[idx].type === 'else'
        ) {
          this.inputContent = ''
          this.showInput = true
          this.qIndex = index
          this.cIndex = idx
          this.zzFormIndex = zzFormIndex
          this.zzMutipleIndex = zzMutipleIndex
          this.$nextTick(() => {
            this.$refs.customInput.focus()
          })
        }
      }
    },
    // 复选框变化,自增表单中其他项变化
    clickCheckBox(e, index, idx, zzFormIndex, zzMutipleIndex, zzInputType) {
      // 判断当前是否选中，并且是否是其他项
      this.zzInputType = zzInputType
      if (!zzInputType) {
        // 普通其他项
        if (
          this.answers[index].answer.includes(idx) &&
          this.anserList[index].answer[idx].type === 'else'
        ) {
          this.inputContent = ''
          this.showInput = true
          this.qIndex = index
          this.cIndex = idx
          this.$nextTick(() => {
            this.$refs.customInput.focus()
          })
        }
      } else if (zzInputType === 'pros') {
        // pros自增项
        if (
          this.answers[index].pros[zzFormIndex].answer.includes(idx) &&
          this.anserList[index].pros[zzFormIndex].answer[idx].type === 'else'
        ) {
          this.inputContent = ''
          this.showInput = true
          this.qIndex = index
          this.cIndex = idx
          this.zzFormIndex = zzFormIndex
          this.$nextTick(() => {
            this.$refs.customInput.focus()
          })
        }
      } else if (zzInputType === 'multiple') {
        if (
          this.answers[index].multipleIds[zzFormIndex][zzMutipleIndex].answer.includes(idx) &&
          this.anserList[index].multipleIds[zzFormIndex][zzMutipleIndex].answer[idx].type === 'else'
        ) {
          this.inputContent = ''
          this.showInput = true
          this.qIndex = index
          this.cIndex = idx
          this.zzFormIndex = zzFormIndex
          this.zzMutipleIndex = zzMutipleIndex
          this.$nextTick(() => {
            this.$refs.customInput.focus()
          })
        }
      }
    },
    // 其他项输入
    inputChange(val) {
      if (!this.zzInputType) {
        // 普通项
        const str = val ? val : '其他____'
        this.$set(this.anserList[this.qIndex].answer[this.cIndex], 'value', str)
        this.$set(this.answers[this.qIndex], 'customOption', str)
        this.$forceUpdate()
      } else if (this.zzInputType === 'pros') {
        const str = val ? val : '其他____'
        this.$set(
          this.anserList[this.qIndex].pros[this.zzFormIndex].answer[this.cIndex],
          'value',
          str
        )
        this.$set(this.answers[this.qIndex].pros[this.zzFormIndex], 'customOption', str)
        this.$forceUpdate()
      } else if (this.zzInputType === 'multiple') {
        const str = val ? val : '其他____'
        this.$set(
          this.anserList[this.qIndex].multipleIds[this.zzFormIndex][this.zzMutipleIndex].answer[
            this.cIndex
          ],
          'value',
          str
        )
        this.$set(
          this.answers[this.qIndex].multipleIds[this.zzFormIndex][this.zzMutipleIndex],
          'customOption',
          str
        )
        this.$forceUpdate()
      }
    },

    // 填空题数量关联
    changeInput(item, qIndex) {
      const { atype } = item
      if (atype === 1) {
        // 查找依赖的自增表单
        const answer = Number(this.answers[qIndex].answer)
        const idx = []
        this.anserList.forEach((v, index) => {
          if (v.zzid === qIndex && v.qtype === 7) {
            idx.push(index)
          }
        })
        if (idx.length > 0) {
          // 如果数量大于1
          if (answer >= 1) {
            idx.forEach(index => {
              this.$set(this.anserList[index], 'show', true)
              // 解决input change的依赖变化调用过大问题，新增字段校验
              this.$set(this.anserList[index], 'inputChangeShow', true)
              this.$set(this.anserList[index], 'multipleIds', [])
              this.$set(this.anserList[index], 'maxInputNum', answer)
            })
          } else if (answer < 1) {
            // 依赖的 idx
            idx.forEach(index => {
              this.$set(this.anserList[index], 'show', false)
              // 解决input change的依赖变化调用过大问题，新增字段校验
              this.$set(this.anserList[index], 'inputChangeShow', false)
              // 设置自增表单的最大数量
              this.$set(this.anserList[index], 'maxInputNum', undefined)
            })
          }
        }
      }
    },

    // 上传文件超出
    onOversize() {
      this.$notify({
        message: '文件大小不能超过10M',
        duration: 1500
      })
    },
    // 上传前 控制图片格式
    beforeRead(image) {
      console.log(image)
      // const typeList = ['image/png', 'image/jpeg']
      // if (!typeList.includes(file.type)) {
      //   this.$notify('仅支持图片上传')
      //   return false
      // }
      // return true
      return new Promise((resolve, reject) => {
        new Compressor(image, {
          quality: 0.4,
          success(result) {
            let file = new File([result], image.name, { type: image.type })
            resolve(file)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
            reject(err)
          }
        })
      })
    },
    // 选择文件后回调
    async afterRead(file, detail) {
      const index = Number(detail.name)
      let fileObj = new FormData()
      fileObj.append('file', file.file)
      axios({
        method: 'post',
        baseURL: process.env.VUE_APP_AXIOS_URL + '/answer/upload',
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorizations: store.getters.userInfo.token
        },
        data: fileObj,
        onUploadProgress() {
          file.status = 'uploading'
          file.message = '上传中...'
        }
      })
        .then(res => {
          if (res.data.code === 200) {
            file.status = 'success'
            file.message = '上传成功'
            this.$set(this.answers[index], 'answer', res.data.data)
            return
          } else {
            file.status = 'failed'
            file.message = '上传失败'
            this.$notify('上传失败，请检查网络是否异常')
            this.$set(this.answers[index], 'fileList', [])
          }
        })
        .catch(() => {
          file.status = 'failed'
          file.message = '上传失败'
          this.$notify('上传失败，请检查网络是否异常')
          this.$set(this.answers[index], 'fileList', [])
        })
    },
    async deleteFile(qIndex) {
      let fileName = this.answers[qIndex].answer
      if (fileName) {
        await deleteUploadFile({ filename: fileName })
      }
      // 删除文件
      this.$set(this.answers[qIndex], 'answer', '')
    },
    // 检查答案的手机号类型是否符合规则
    // 1. 只检查显示的问题
    // 2. 只检查手机号类型 qtype = 5
    checkAnswerPhone(answers, answersList) {
      let answerFlag = true
      for (let i = 0; i < answersList.length; i++) {
        let item = answersList[i]
        let { qtype, show } = item
        if (qtype === 5 && show) {
          let answerValue = answers[i].answer
          // 检查 answer value 是否符合手机号规则
          if (!checkValidUserPhone(answerValue)) {
            answerFlag = false
            break
          }
        }
      }
      return answerFlag
    },
    onSubmit() {
      // if (this.isRequest) return
      // const list1 = this.answers.filter(item => item.qtype !== 4)
      let _this = this
      let flag = false // 判断是否有题目未答题
      let zzFlag = false // 判断是否有自增题目数量不符合情况
      let questionIndex = 0 // 所有题目第几道题
      let numQuestionIndex = 0 // 题号

      for (let index = 0; index < this.anserList.length; index++) {
        let data = this.anserList[index]
        if (data.show) {
          if (data.qtype < 4 && data.flag && this.checkEmpty(this.answers[index].answer)) {
            flag = true
            questionIndex = index
            if (flag) break
          } else if (data.qtype === 7) {
            flag = data.pros.some((item, idx) => {
              if (item.flag && item.show && this.checkEmpty(this.answers[index].pros[idx].answer)) {
                return true
              }
            })
            questionIndex = index
            if (flag) break
            // 补充自增表单检查
            if (data.multipleIds && data.multipleIds.length > 0) {
              flag = data.multipleIds.some((item, idx) => {
                return item.some((v, ix) => {
                  if (
                    v.flag &&
                    v.show &&
                    this.checkEmpty(this.answers[index].multipleIds[idx][ix].answer)
                  ) {
                    return true
                  }
                })
              })
            }
            questionIndex = index
            console.log('index', index, flag)
            if (flag) break
          } else if (data.qtype !== 7 && data.flag && this.answers[index].answer === '') {
            flag = true
            questionIndex = index
            if (flag) break
          }
        }
      }

      // 验证自增表单类型数量是否符合规定
      function checkZZShowNum(answers, zzid, current) {
        if (zzid !== null && zzid !== undefined) {
          let numZZid = Number(zzid)
          // 数量关联的答案
          let dependAnswer = Number(answers[numZZid].answer)
          if (current.multipleIds.length !== dependAnswer - 1) {
            // 不符合自增数量的依赖
            return true
          }
          return false
        }
        return false
      }

      // 提示必填项
      if (flag) {
        this.$notify('请填写所有必填项目')
        let key = 'question_' + questionIndex
        console.log('key', key, questionIndex, this.anserList)
        this.$refs[key][0].scrollIntoView()
        return
      }

      // 检查自增表单数量依赖是否符合
      this.anserList
        .filter((item, index) => {
          item.__index = index
          return item.show
        })
        .some((data, index) => {
          if (data.qtype === 7) {
            zzFlag = checkZZShowNum(this.answers, data.zzid, data)
            if (zzFlag) {
              questionIndex = data.__index
              numQuestionIndex = index
            }
            return zzFlag
          }
          return false
        })
      // 提示自增表单选项数量不符的情况
      if (zzFlag) {
        let zzid = this.anserList[questionIndex].zzid
        let requiredNum = this.answers[Number(zzid)].answer
        this.$notify(`第${numQuestionIndex + 1}题至少需要${requiredNum}项`)
        let key = 'question_' + questionIndex
        console.log('key', key)
        this.$refs[key][0].scrollIntoView()
        return
      }
      // const checkFlag = this.answers.some(item => {
      //   // 检查所有必填项
      //   return Number(item.flag) === 1 && (!String(item.answer) || item.answer.length === 0)
      // })
      // if (checkFlag) {
      //   this.$notify({
      //     message: '请填写所有必填项'
      //   })
      //   return
      // }
      if (!this.location.lat) {
        this.$notify({
          message: '未获取到位置信息，提交失败，请打开手机定位'
        })
        return
      }
      const list = []

      // 检查答案手机号类型
      if (!this.checkAnswerPhone(this.answers, this.anserList)) {
        this.$notify({
          message: '请填写正确的手机号'
        })
        return
      }

      /**
       * item: 保存的答案对象
       * currentAns: 当前问题题目(携带show, options选项的对象)
       * data: 格式化的结果
       */
      function Convert(item, currentAns, data) {
        console.log(item, currentAns, data)
        // debugger
        const { qtype } = item
        let options = []
        // 初始绑定的答案
        // answer：初始绑定的答案
        // result：选项绑定的结果
        data.answer = Array.isArray(item.answer) ? JSON.stringify(item.answer) : item.answer
        switch (qtype) {
          case 0:
            // 填空题答案
            data.result = item.answer
            data.ans = JSON.stringify(currentAns.answer)
            break
          case 1:
            // 单选题答案
            item.answer = item.answer === '' ? 0 : item.answer
            data.result = currentAns.answer[item.answer].value
            data.ans = JSON.stringify(currentAns.initialAnswer)
            break
          case 2:
            // 多选
            item.answer.forEach(itm => {
              options.push(currentAns.answer[itm].value)
            })
            data.result = options.join(',')
            data.ans = JSON.stringify(currentAns.initialAnswer)
            data.answer = JSON.stringify(item.answer)
            break
          default:
            data.result = item.answer
            // data.ans = JSON.stringify(currentAns.answer);
            break
        }
        data.multipleIds = JSON.stringify(data.multipleIds)
        return data
      }

      // 合成答案并保存
      this.answers.forEach((item, index) => {
        if (this.anserList[index].show) {
          let data = {
            ...item,
            result: item.answer
          }
          if (item.qtype !== 7) {
            data = Convert(item, this.anserList[index], data)
          } else {
            // 当前问题
            let currentAns = this.anserList[index]
            let multipleIds = cloneDeep(currentAns.multipleIds)
            let pros = cloneDeep(currentAns.pros)
            // 转换原始默认的数据
            currentAns.pros.forEach((v, idx) => {
              pros[idx] = {
                ...v,
                ...Convert(item.pros[idx], currentAns.pros[idx], pros[idx])
              }
            })
            // 转换补充的自增表单数据
            currentAns.multipleIds.forEach((v, idx) => {
              v.forEach((w, idy) => {
                multipleIds[idx][idy] = {
                  ...w,
                  ...Convert(
                    item.multipleIds[idx][idy],
                    currentAns.multipleIds[idx][idy],
                    multipleIds[idx][idy]
                  )
                }
              })
            })
            // 过滤不显示的选项
            pros = pros.filter(item => item.show)
            // 移除不需要的字段
            delete data.pros
            data.multipleIds = JSON.stringify(multipleIds)
            data.answer = JSON.stringify(pros)
          }

          list.push({
            ...data,
            fileList: '' // 清除上传文件的base64图片数据
          })
        }
      })

      const data = {
        lat: this.location.lat,
        lon: this.location.lon,
        uid: this.userInfo.user.id,
        name: this.detailInfo.name,
        qid: this.detailInfo.id,
        time: parseInt((new Date().getTime() - this.startTime) / 1000),
        userName: this.userInfo.user.userName || '',
        list: list,
        // image: this.image,
        countys: this.code,
        browsermark: checkPhone()
        // ...this.exifInfo
      }
      // 判断是否有推广信息
      const shareInfo = store.getters.shareInfo
      if (shareInfo) {
        if (
          Number(shareInfo.t_id) !== Number(this.userInfo.user.id) &&
          shareInfo.q_id === this.qid
        ) {
          data.tid = shareInfo.t_id
        }
      }
      this.isRequest = true
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定保存并提交吗'
        })
        .then(() => {
          insertAnswer(data)
            .then(res => {
              if (res.error) {
                return
              }
              if (String(data.tid)) {
                localStorage.removeItem('shareInfo')
                // 判断之前是否用过推广id, 用过删除
              }
              this.success = true
            })
            .finally(() => {
              _this.isRequest = false
            })
        })
      // insertAnswer(data).then(res => {
      //   if (res.error) {
      //     return
      //   }
      //   if(String(data.tid)) {
      //     localStorage.removeItem('shareInfo')
      //     // 判断之前是否用过推广id, 用过删除
      //   }
      //   this.success = true
      // }).finally(() => {
      //   this.isRequest = false
      // })
    },
    shareQuestion() {
      this.showShareInfo = true
    },
    goBack() {
      this.$router.replace('/my/index')
    },
    closeShare() {
      this.showShareInfo = false
    },
    onLaunch(e) {
      console.log(e, 'lanch')
    },
    onError(e) {
      console.log(e, 'error')
    },
    startAnser() {
      this.showQuestion = true
      this.startTime = new Date().getTime()
    },
    getUserImg() {
      this.timer = setInterval(async () => {
        let res = await getImage({
          uid: this.userInfo.user.id,
          qid: this.qid
        })
        if (res.data && res.data.qimageAddress) {
          this.qimageAddress =
            process.env.VUE_APP_BASE_URL + '/static/image/' + res.data.qimageAddress
        }
      }, 1500)
      // let res = await getImage({
      //   uid: this.userInfo.user.id,
      //   qid: this.qid
      // })
      // if (!res.error) {
      //   if (res.data && res.data.qimageAddress) {
      //     this.qimageAddress = process.env.VUE_APP_BASE_URL + '/static/image/' + res.data.qimageAddress
      //   } else {
      //     this.getUserImg()
      //   }
      // }
    },
    // 检查是否为空
    checkEmpty(val) {
      if (Array.isArray(val)) {
        return val.length === 0
      } else {
        return !val && String(val) !== '0'
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  components: {
    shareDialog: () => import('./showShare')
  }
  //  beforeRouteLeave (to, from, next) {
  //     if(!this.success) {
  //       this.$dialog.confirm({
  //         title: '提示',
  //         message: '问卷尚未作答完毕，确定离开当前页面吗？',
  //         beforeClose(action, done) {
  //           if (action === 'confirm') {
  //             done()
  //             next()
  //           } else {
  //             done()
  //             window.history.go(1)
  //           }
  //         }
  //       })
  //     } else {
  //       next()
  //     }
  //  }
}
</script>

<style lang="stylus" scoped>
.questionDetail {
  min-height: 100vh;
  background: #f2f2f2;
  // padding-bottom: 40px;
  .shareBtn {
    position: fixed;
    right: 8px;
    bottom: 160px;
    background: #368bff;
    border-radius: 10px 0 0 10px;
    width: 44px;
    padding: 27px 0;
    text-align: center;
    font-size: 26px;
    color: #fff;
  }
  .success {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 150px
    .successContent {
      width: 500px
      .thanks {
        color: #333333;
        font-size: 40px;
        font-weight: bold;
        margin-top: 28px;
        text-align: center;
      }
      .introTitle {
        // margin-top: 50px;
        font-weight: bold;
        color: #333333;
        text-align: center;
        font-size: 40px;
      }
      .introContent {
        margin-top: 30px;
        // font-weight: bold;
        color: #333333;
        // text-align: center;
        font-size: 30px;
        // padding: 0 100px;
        line-height: 1.7;
      }
      .shareImg{
        width: 494px;
        height: 362px;
      }
      .buttons {
        margin-top: 60px;
        .button {
          text-align: center;
          border-radius: 45px;
          font-size: 28px;
          height: 90px;
          line-height: 90px;
        }
        .shareButton {
          background: #368BFF;
          color: #fff;
        }
        .returnButton {
          margin-top: 20px;
          background: #F8F9FD;
          color: #368BFF;
        }
      }
      .caution {
        // position: fixed;
        // width: 100%;
        // right: 0;
        // bottom: 70px;
        margin-top: 50px
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .content{
    padding: 0 30px 30px 30px;
    .title {
      padding-top: 30px;
      font-size: 40px;
      font-weight: bold;
      color: #368BFF;
      text-align: center;
    }
    .remark {
      margin: 50px 0;
      font-size: 30px;
      color: #333333;
      font-weight: 400;
      white-space: break-spaces;
    }
    .splitLine {
      margin-bottom: 60px;
      height: 1PX;
      border-bottom: 1PX dashed rgba(0, 0, 0, 0.1);
    }
    .list {
      .item {
        display: none;
        background: #fff;
        margin-bottom: 30px
        padding: 30px 10px;
        .item-title{
          color: #333333;
          font-size: 30px;
          font-weight: 500;
          // padding-right: 30px;
          // display: flex;
          // align-items: center;
          // flex-wrap: wrap;
          .required {
            display: inline-block;
            color: red;
            width: 30px;
            height: 30px;
            line-height: 13px;
            .required-icon {
              width: 30px;
              height: 30px
            }
          }
          .index {
            margin-right: 3px;
          }
          .unit, .type {
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            margin-left: 20px;
            line-height: 42px
          }
          .unit {
            color: red
          }
        }
        .item-descri {
          color: #888888;
          font-weight: 400;
          font-size: 22px;
          padding: 0 30px;
          margin-top: 10px;
        }
        .custom-check {
          padding: 8PX 0;
          /deep/.van-checkbox__label, /deep/.van-radio__label, {
            color: #333333;
            font-weight: 400;
            font-size: 28px !important;
          }
        }
        .item-question-model {
          padding: 0 30px;
        }
      .myAddForm {
        margin-top: 30px;
        border: 1px solid rgba(0,0,0,0.1);
        .subtitle {
          font-size: 34px;
          color: #333333;
          padding: 20px 30px;
          background: #F0F0F0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        // 不显示
        .zzbd {
          padding: 5px 30px;
          display: none;
        }
        // 显示自增
        .showZzbd {
          display: block
        }
        .addIcon,
        .removeIcon {
          width: 32px;
          height: 32px;
        }
        .removeIcon {
          margin-right: 20px
        }
      }
        .custom-input-template {
          margin-top: 24px;
          .default {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            width: 100%;
            display: flex;
            height: 60px;
            align-items: center;
            .icon {
              width: 26px;
              height: 26px;
              margin-right: 20px;
            }
            .sudiao-input {
              flex: 1;
              font-size: 28px;
              color: #333333;
              font-weight: 400;
              border: none;
              // width: 100%;
              height: 95%
              outline: none;
              padding: 0;
              margin: 0;
            }
            /deep/ .van-cell {
              padding: 0
            }
          }
        }
        .custom-check-template, .custom-file-template {
          margin-top: 30px;
          // padding: 0 30px
          /deep/ .van-uploader__upload {
            margin: 0
          }
        }
      }
      .showItem{
        display: block !important;
      }
    }
  }
  .submitButton {
    margin-top: 50px;
    // margin-bottom: 20px;
    display: flex;
    justify-content: center;
    .custom-button {
      width: 100%;
      font-size: 28px;
      height: 90px;
      color: #fff;
      background: #368BFF;
      border-radius: 45px;
      display: flex;
      justify-content: center;
      align-items: center
    }
  }
  .custom-loading {
    position: fixed;
    top: 45%;
    left: 40%;
  }
  .contentArea {
    min-height: 100vh;
    padding-bottom: 20px;
    background: #fff;
    .notArea {
      img {
        width: 100%;
        height: 343px;
      }
    }
    .introTitle {
      // margin-top: 50px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      font-size: 40px;
    }
    .introContent {
      margin-top: 30px;
      // font-weight: bold;
      color: #333333;
      // text-align: center;
      font-size: 30px;
      padding: 0 100px;
      line-height: 1.7
    }
    .waiting {
      margin-top: 40px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      .waitingBtn {
        width: 500px;
        background: linear-gradient(135deg, #368BFF, #368BFF);
        border-radius: 45px;
        line-height: 90px;
        height: 90px;
        text-align: center;
        font-size: 28px;
        font-weight: 500;
        color: #FFFFFF;
      }
      .isWaiting {
        background: #CCCCCC;
      }
    }
  }
  .customHtml {
    font-size: 30px;
    /deep/ p{
      margin: 0 !important;
      color: #333 !important;
    }
  }
}
</style>
